import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  getNotMeasuredSettings,
  putNotMeasuredSettings,
  getNotMeasuredDeviceTypeMap,
} from 'services/api';
import { pushNotification } from 'features/notifications/notificationsSlice';
import { i18n } from 'utils';
import { NotMeasuredSettings } from './interface';

export const getNotMeasuredSettingsAsync: any | null = createAsyncThunk(
  'notMeasuredSettings/get',
  async () => {
    const response = await getNotMeasuredSettings();
    return response?.data;
  },
);

export const putNotMeasuredSettingsAsync: any | null = createAsyncThunk(
  'notMeasuredSettings/put',
  async (data: NotMeasuredSettings, { dispatch }) => {
    const response = await putNotMeasuredSettings(data);
    if (response?.data?.success) {
      dispatch(pushNotification({ message: i18n('notMeasuredSettings.saved'), severity: 'success' }));
      dispatch(getNotMeasuredSettingsAsync());
    }
    return response;
  },
);

export const getNotMeasuredDeviceTypeMapAsync: any | null = createAsyncThunk(
  'notMeasuredSettings/getDeviceMap',
  async () => {
    const response = await getNotMeasuredDeviceTypeMap();
    return response?.data;
  },
);
